import type { FaqItem } from "@/utils/blog/faq";
import { toTrackSlug } from "@/utils/track-slug";

export interface BlogFaqProps {
  items: FaqItem[];
}

/**
 * «Частые вопросы» — the FAQ card list parsed from the trailing
 * `## Частые вопросы` markdown section. Native `<details>` accordion (no JS,
 * accessible, hydration-safe); the FAQPage JSON-LD is emitted separately from
 * the same parsed items.
 */
export function BlogFaq({ items }: BlogFaqProps) {
  if (items.length === 0) return null;

  return (
    <section className="blog-faq" data-component="BlogFaq" aria-labelledby="blog-faq-heading">
      <h2 id="blog-faq-heading" className="blog-section-heading">
        Частые вопросы
      </h2>
      <div className="blog-faq-list">
        {items.map((item) => (
          <details
            key={item.question}
            className="blog-faq-item"
            data-track={`blog-article.faq.${toTrackSlug(item.question)}`}
          >
            <summary className="blog-faq-q">
              <span>{item.question}</span>
              <span className="blog-faq-icon" aria-hidden="true" />
            </summary>
            <div className="blog-faq-a">
              {item.answer
                .split(/\n{2,}/)
                .map((para) => para.trim())
                .filter(Boolean)
                .map((para) => (
                  <p key={para}>{para}</p>
                ))}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}

BlogFaq.displayName = "BlogFaq";
